import { render, staticRenderFns } from "./SobreNos.vue?vue&type=template&id=45b0a063&"
import script from "./SobreNos.vue?vue&type=script&lang=js&"
export * from "./SobreNos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports